import { BlockType } from './enums';
// all available block types, in custom order
export const AllBlockTypes = [
    BlockType.Order,
    BlockType.Activity,
    BlockType.Account,
    BlockType.PriceChart,
    BlockType.Quote,
    BlockType.Info,
    BlockType.OptionChain,
    BlockType.Positions,
    BlockType.Favorites,
    BlockType.AccountTransfer,
    BlockType.AccountManagement,
    BlockType.AdminTools,
    BlockType.Analytics,
    BlockType.AccountStatements,
    BlockType.SubAccountManagement,
    BlockType.AdminCashiering,
];
export const AllBlocksCategorized = {
    front: [
        BlockType.Order,
        BlockType.Quote,
        BlockType.OptionChain,
        BlockType.PriceChart,
        BlockType.Favorites,
        BlockType.Info,
    ],
    middle: [BlockType.Positions, BlockType.Activity, BlockType.AccountTransfer],
    back: [
        BlockType.Account,
        BlockType.AccountStatements,
        BlockType.AccountManagement,
        BlockType.Analytics,
        BlockType.AdminTools,
        BlockType.SubAccountManagement,
        BlockType.AdminCashiering,
    ],
};
//# sourceMappingURL=Blocks.js.map